"use strict";

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberGreaterThanOrEqualTo = exports.default = void 0;

var _default = function _default(props, propName, componentName, expectedValue) {
  if (props[propName] !== expectedValue) {
    return new Error("'".concat(propName, "' in '").concat(componentName, "'\n\nWoah, hold on player!!!\n\nYou may NOT pass in a prop value for '").concat(propName, "'. ") + 'I mean, bro, it had 2 underscores in the prop name for a reason. Now, if you would kindly remove it, we could all go about our day.\n');
  }
};

exports.default = _default;

var numberGreaterThanOrEqualTo = function numberGreaterThanOrEqualTo(props, propName, componentName, expectedValue) {
  if (props[propName] < expectedValue) {
    return new Error("'".concat(propName, "' in '").concat(componentName, "'\n\nWoah, hold on player!!!\n\nYou passed in an invalid prop value for '").concat(propName, "'. ") + "You need to pass in a number greater than or equal to '".concat(expectedValue, "'\n"));
  }
};

exports.numberGreaterThanOrEqualTo = numberGreaterThanOrEqualTo;